// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"418":"d983689097de6df8","980":"aee625fdb054488f"}[chunkId] + ".css";
};